export default __webpack_public_path__ + "static/media/sanmar3.f1429e48.jpg";